"use client";

import { useState } from "react";
import { Text, Box as MantineBox, UnstyledButton as MantineUnstyledButton } from "@mantine/core";

import styles from "./BrandSearchPage.module.scss";

const MAX_DESCRIPTION_LENGTH = 100;

interface BrandDescriptionProps {
  description: string;
  className?: string;
}

export function BrandDescription({ description, className }: BrandDescriptionProps) {
  const [expanded, setExpanded] = useState(false);

  const shouldShowReadMore = description && description.length > MAX_DESCRIPTION_LENGTH;
  const displayDescription =
    shouldShowReadMore && !expanded
      ? description.slice(0, MAX_DESCRIPTION_LENGTH) + "..."
      : description;

  return (
    <MantineBox className={className}>
      <Text size="sm" className={styles.description}>
        {displayDescription}
      </Text>
      {shouldShowReadMore && (
        <MantineUnstyledButton
          className={styles.readMoreButton}
          onClick={() => setExpanded(!expanded)}
          type="button"
        >
          {expanded ? "[− Show less]" : "[+ Read more]"}
        </MantineUnstyledButton>
      )}
    </MantineBox>
  );
}
